import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useMutation } from "@faire/web-api--source/api/v2/addresses/validate-phone-number/post-hooks";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { useCallback, useRef, useState } from "react";
export var usePhoneNumberValidator = function() {
    var mutateAsync = useMutation().mutateAsync;
    var lastValidatingPhoneNumber = useRef(undefined);
    var _useState = _sliced_to_array(useState(false), 2), isPending = _useState[0], setIsPending = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isInvalid = _useState1[0], setIsInvalid = _useState1[1];
    var validatePhoneNumber = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(phoneNumber, country) {
            var res;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lastValidatingPhoneNumber.current = phoneNumber;
                        setIsPending(true);
                        if (!(phoneNumber.trim().length === 0)) return [
                            3,
                            1
                        ];
                        setIsInvalid(true);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            mutateAsync([
                                {
                                    phone_number: phoneNumber,
                                    country: country ? ISO3166Alpha3[country] : undefined
                                }
                            ])
                        ];
                    case 2:
                        res = _state.sent();
                        setIsInvalid(!res.is_valid);
                        _state.label = 3;
                    case 3:
                        setIsPending(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(phoneNumber, country) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutateAsync
    ]);
    var isPhoneNumberInvalid = useCallback(function(phoneNumber) {
        return lastValidatingPhoneNumber.current && phoneNumber.localeCompare(lastValidatingPhoneNumber.current) === 0 && isInvalid;
    }, [
        lastValidatingPhoneNumber,
        isInvalid
    ]);
    return {
        isPending: isPending,
        isInvalid: isInvalid,
        validatePhoneNumber: validatePhoneNumber,
        isPhoneNumberInvalid: isPhoneNumberInvalid
    };
};
